import getConfig from "next/config";
import { useCallback, useEffect, useRef, useState } from "react";

const {
  publicRuntimeConfig: {
    footprints: { homepageSliderDataSourceId },
  },
} = getConfig();

const FOOTPRINTS_HOMEPAGE_SLIDER_ID = "FootprintsHomepageSlider";

const SLOT_CLASS_NAMES = [
  "ffrWebAdvertising1240x360webAdsSlider",
  "ffrWebAdvertising360x240webAdsSlider",
];

const FootprintsHomepageSlider = ({ onSlidesChange }) => {
  const [hasSlides, setHasSlides] = useState(false);
  const wrapperRef = useRef(null);
  const onSlidesChangeRef = useRef(onSlidesChange);

  onSlidesChangeRef.current = onSlidesChange;

  const loadScript = useCallback(() => {
    const script = document.createElement("script");
    script.src = `https://at-ffr-ai.altex.ro/web-advertising-slider/${homepageSliderDataSourceId}/web_advertising_slider/script.js?hostUrl=${encodeURIComponent(
      window.location.href
    )}`;
    script.id = FOOTPRINTS_HOMEPAGE_SLIDER_ID;
    script.async = true;

    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    loadScript();

    return () => {
      // Cleanup script on component unmount
      const script = document.getElementById(FOOTPRINTS_HOMEPAGE_SLIDER_ID);

      if (script) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // Track whether the script actually filled the slots, instead of keying off
  // its `onload`: the script loads even when the ads API returns no content,
  // and it fills the slots later, once that request answers. Reporting this up
  // lets the page keep the CMS banners on screen while the slots are empty.
  useEffect(() => {
    const wrapper = wrapperRef.current;

    if (!wrapper) {
      return undefined;
    }

    const syncSlides = () => {
      const isFilled = SLOT_CLASS_NAMES.some(
        (className) => wrapper.querySelector(`.${className}`)?.childElementCount
      );

      setHasSlides(isFilled);
      onSlidesChangeRef.current?.(isFilled);
    };

    const observer = new MutationObserver(syncSlides);

    observer.observe(wrapper, { childList: true, subtree: true });
    syncSlides();

    return () => {
      observer.disconnect();
      onSlidesChangeRef.current?.(false);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`${
        hasSlides ? "flex justify-center items-center py-[20px]" : "invisible"
      }`}
    >
      <div className="ffrWebAdvertising1240x360webAdsSlider" />

      <div className="ffrWebAdvertising360x240webAdsSlider" />
    </div>
  );
};

export default FootprintsHomepageSlider;
